import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppUpdateSplashService } from '@safarilaw-webapp/shared/app-bootstrap/data-access';
import { SafariInjector } from '@safarilaw-webapp/shared/common-objects-models';
import { Subscription } from 'rxjs';

const SCENE_FILES = [
  'scene-elephant.webp',
  'scene-elephants.webp',
  'scene-gazelles.webp',
  'scene-giraffe.webp',
  'scene-hole1.webp',
  'scene-lion.webp',
  'scene-lions.webp',
  'scene-meerkats.webp',
  'scene-rhino.webp',
  'scene-zebra.webp',
  'scene-zebras.webp'
];

const MOTE_COUNT = 14;

interface Mote {
  sizePx: number;
  leftPct: number;
  topPct: number;
  durationS: number;
  delayS: number;
  background: string;
}

const randomMoteColor = (): string => {
  const r = Math.round(170 + Math.random() * 40);
  const g = Math.round(140 + Math.random() * 30);
  const b = Math.round(80 + Math.random() * 30);
  const a = (0.18 + Math.random() * 0.15).toFixed(2);
  return `rgba(${r},${g},${b},${a})`;
};

@Component({
  selector: 'sl-lpms-update-splash',
  templateUrl: './app-update-splash.html',
  styleUrls: ['./app-update-splash.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: []
})
export class AppUpdateSplashComponent extends SafariInjector implements OnInit, OnDestroy {
  sceneUrl: string = null;
  motes: Mote[] = [];
  private _appUpdateSplashServiceSubscription: Subscription = null;
  private _appUpdateSplashService: AppUpdateSplashService;
  private _previousBodyOverflow: string = null;
  constructor() {
    super();
    this._appUpdateSplashService = this.inject(AppUpdateSplashService);
  }
  ngOnInit(): void {
    this._initScene();
    this._appUpdateSplashServiceSubscription = this._appUpdateSplashService.subscribe(() => {
      this._previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    });
  }
  ngOnDestroy(): void {
    if (this._appUpdateSplashServiceSubscription) {
      this._appUpdateSplashServiceSubscription.unsubscribe();
      this._appUpdateSplashServiceSubscription = null;
    }
    if (this._previousBodyOverflow != null) {
      document.body.style.overflow = this._previousBodyOverflow;
      this._previousBodyOverflow = null;
    }
  }
  get errorMessage() {
    return window['swError'];
  }
  onSceneError(): void {
    this.sceneUrl = null;
  }
  private _initScene(): void {
    this.sceneUrl = `/img/scenes/${SCENE_FILES[Math.floor(Math.random() * SCENE_FILES.length)]}`;
    this.motes = Array.from({ length: MOTE_COUNT }, () => ({
      sizePx: 1.5 + Math.random() * 2.5,
      leftPct: 10 + Math.random() * 80,
      topPct: 20 + Math.random() * 50,
      durationS: 7 + Math.random() * 10,
      delayS: Math.random() * 8,
      background: randomMoteColor()
    }));
  }
}
